import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { SEAT_MAP } from '../../../products';
import { loadImage } from '../utils/header';
import FromToLabel from '../../components/FromToLabel';
import StepIndicator from './StepIndicator/StepIndicator';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = image => css`
  align-items: center;
  background: ${`${etiColors.grayScale[4]} ${image !== null ? `url(${image})` : ``}`};
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: ${etiColors.white};
  position: relative;

  &::before {
    background-color: #09364c;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    content: '';
    display: block;
    inset: 0;
    opacity: 0.9;
    position: absolute;
  }
`;
const contentStyles = css`
  padding: 0 0.875rem;
  text-align: center;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    padding: 0 15px;
  }

  @media ${mediaQueries.large.up} {
    padding: 0 30px;
  }
`;
const headerTextStyles = css`
  font-size: 0.875rem;
  margin: 0.625rem 0;
  position: relative;

  @media ${mediaQueries.medium.up} {
    margin: 1.25rem 0;
  }
`;
const originDestinationTextStyles = css`
  display: flex;
  font-weight: 600;
  justify-content: center;
  opacity: 1;

  @media ${mediaQueries.medium.up} {
    font-size: 1.25rem;
  }
`;
const titleStyles = css`
  display: none;

  @media ${mediaQueries.medium.up} {
    display: block;
  }
`;
const SeatMapHeader = _ref => {
  let {
    active,
    allSelectedSeats,
    flattenedBounds,
    from,
    shouldShowSummary,
    to,
    onNextSegmentClick,
    onPreviousSegmentClick,
    onSegmentClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const label = t('Product.SeatMap.Segment.Header');
  const [backgroundImage, setBackgroundImage] = useState(null);
  useEffect(() => {
    const fetchImage = async () => {
      const {
        name
      } = SEAT_MAP;
      try {
        const loadedImage = await loadImage(name);
        setBackgroundImage(loadedImage);
      } catch (error) {
        console.error(`Warning: No image was found for the ’${name}’ product`); // eslint-disable-line no-console
      }
    };
    fetchImage();
  }, [active]);
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles(backgroundImage),
    "data-testid": "seatMap-header",
    children: /*#__PURE__*/_jsxs("div", {
      className: contentStyles,
      children: [/*#__PURE__*/_jsxs("div", {
        className: headerTextStyles,
        children: [/*#__PURE__*/_jsx("div", {
          className: titleStyles,
          "data-testid": "seatMap-label-text",
          children: label
        }), /*#__PURE__*/_jsx("p", {
          className: originDestinationTextStyles,
          "data-testid": "seatMap-originAndDestinations-text",
          children: /*#__PURE__*/_jsx(FromToLabel, {
            from: from,
            to: to
          })
        })]
      }), /*#__PURE__*/_jsx(StepIndicator, {
        active: active,
        allSelectedSeats: allSelectedSeats,
        flattenedBounds: flattenedBounds,
        onNextSegmentClick: onNextSegmentClick,
        onPreviousSegmentClick: onPreviousSegmentClick,
        onSegmentClick: onSegmentClick,
        shouldShowSummary: shouldShowSummary
      })]
    })
  });
};
SeatMapHeader.propTypes = {
  active: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  allSelectedSeats: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.arrayOf(PropTypes.any)]),
  flattenedBounds: PropTypes.arrayOf(PropTypes.any),
  from: PropTypes.string,
  onNextSegmentClick: PropTypes.func,
  onPreviousSegmentClick: PropTypes.func,
  onSegmentClick: PropTypes.func,
  shouldShowSummary: PropTypes.bool,
  to: PropTypes.string
};
export default SeatMapHeader;
//# sourceMappingURL=SeatMapHeader.js.map